import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format, fromUnixTime } from 'date-fns';

const TimestampAgo = (props) => {
  const { value} = props;
  const [timeAgo, setTimeAgo] = useState(value);

  useEffect(() => {
    if (value !== '' && parseInt(value, 10) > 1) {
      if(fromUnixTime(value)==="Invalid Date"){
        let t= value.split(".");
        setTimeAgo(t[0]);
      }else{
        let now=new Date();
        let sec=Math.floor((now-Math.floor(value))/1000);
        if(sec<0){
          setTimeAgo('0 secs ago');
        }else if(sec<60){
          setTimeAgo(sec + " secs ago");
        }else{
          let min=Math.floor(sec/60);
          if(min<60){
            setTimeAgo(min +" mins ago");
          }else{
            let hours=Math.floor(min/60);
            if(hours>24){
              var date = new Date(value);
              setTimeAgo(format(date, 'dd/MM/yyyy H:mm:ss'))
            }else
              setTimeAgo(hours+" hours ago");
          }
        }  
      }
    }else{
      setTimeAgo("No time");
    }
  }, [value]);

  return (
    <div>
      {timeAgo}
    </div>
  );
};

TimestampAgo.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

TimestampAgo.defaultProps = {
  value: '',
};

export default TimestampAgo;
